// 会员卡系统
const appid = localStorage.getItem("app_id");
export const vipData = [
  {
    path: "/apply/newVip/13/home/vipIndex",
    name: "首页",
    icon: "el-icon-s-home",
    children: []
  },
  //便利店
  {
    path: "/apply/newVip/13/convenience_store",
    name: "便利店",
    icon: "el-icon-s-ticket",
    children: [
      {
        path: "/apply/newVip/13/convenience_store/index",
        name: "商品列表"
      },
      {
        path: "/apply/newVip/13/convenience_store/order",
        name: "商品订单"
      }
    ]
  },
  {
    path: "/apply/newVip/13/shop",
    name: "门店",
    icon: "el-icon-s-shop",
    children: [
      {
        path: "/apply/newVip/13/shop/shopList",
        name: "门店列表"
      },
      {
        path: "/apply/newVip/13/set/role",
        name: "角色管理"
      },
      {
        path: "/apply/newVip/13/set/employee",
        name: "员工管理"
      },
      {
        path: "/apply/newVip/13/set/compose/classList",
        name: "排班设置"
      },
      {
        path: "/apply/newVip/13/home/royalties",
        name: "员工提成"
      }
    ]
  },

  {
    path: "/apply/newVip/13/refuel",
    name: "业务",
    icon: "el-icon-s-cooperation",
    children: [
      {
        path: "/apply/newVip/13/refuel",
        name: "加油管理",
        children: [
          {
            path: "/apply/newVip/13/refuel/category",
            name: "油品类别"
          },
          {
            path: "/apply/newVip/13/refuel/list",
            name: "油品列表"
          },
          {
            path: "/apply/newVip/13/refuel/equipment",
            name: "油枪管理"
          }
        ]
      },
      // {
      //   path: "/apply/newVip/13/business/",
      //   name: "常用业务",
      //   children: [
      //     {
      //       path: "/apply/newVip/13/business/actlist",
      //       name: "活动列表"
      //     }
      //   ]
      // },
      // {
      //   path: "/apply/newVip/13/business/getMoney",
      //   name: "消费收款"
      // },
      {
        path: "/apply/newVip/13/business/recharge",
        name: "快速充值"
      },
      {
        path: "/apply/newVip/13/collection/list",
        name: "收款码"
      },
      {
        path: "/apply/newVip/13/serve",
        name: "门店服务"
      },
      {
        path: "/apply/newVip/13/business/couponTaskList",
        name: "任务"
      },
      // 移到营销里
      // {
      //   path: "/apply/newVip/13/rechargeSet",
      //   name: "充值赠送"
      // },
      {
        path: "/apply/newVip/13/carWash/shop",
        name: "洗车服务",
        children: [
          {
            path: "/apply/newVip/13/carWash/shop",
            name: "洗车门店"
          },
          {
            path: "/apply/newVip/13/carWash/order?room_id=0",
            name: "洗车订单"
          }
        ]
      }
      // {
      //   path: "/apply/newVip/13/business/meal_list",
      //   name: "套餐管理",
      //   children: [
      //     {
      //       path: "/apply/newVip/13/business/meal_list",
      //       name: "套餐列表"
      //     },
      //     {
      //       path: "/apply/newVip/13/business/admeal",
      //       name: "套餐设置"
      //     }
      //   ]
      // },
      // {
      //   path: "/apply/newVip/13/business/yuelist",
      //   name: "预约",
      //   children: [
      //     {
      //       path: "/apply/newVip/13/business/yuelist",
      //       name: "预约列表"
      //     },
      //     {
      //       path: "/apply/newVip/13/business/setyue",
      //       name: "预约设置"
      //     }
      //   ]
      // }
    ]
  },
  {
    path: "/apply/newVip/13/card",
    name: "会员",
    icon: "el-icon-s-finance",
    children: [
      {
        path: "/apply/newVip/13/card/levelGroup",
        name: "会员卡"
      },
      {
        path: "/apply/newVip/13/card/refule",
        name: "加油卡"
      },
      {
        path: "/apply/newVip/13/home/wxCard",
        name: "微信卡券"
      },
      {
        path: "/apply/newVip/13/home/miniCard",
        name: "小程序卡券"
      },
      {
        path: "/apply/newVip/13/set/familyCard",
        name: "亲属卡"
      }
    ]
  },
  //平台卡
  {
    path: "/apply/newVip/13/card/activityCard",
    name: "活动",
    icon: "el-icon-s-ticket",
    children: [
      {
        path: "/apply/newVip/13/card/activityCard/index",
        name: "平台卡"
      },
      {
        path: "/apply/newVip/13/card/activityCard/card_order_list",
        name: "平台卡订单"
      },
      {
        path: "/apply/newVip/13/card/activityCard/card_user_list",
        name: "用户平台卡"
      }
    ]
  },
  {
    path: "/apply/newVip/13/motorcade/index",
    name: "车队",
    icon: "el-icon-s-finance",
    children: [
      {
        path: "/apply/newVip/13/motorcade/index",
        name: "车队卡"
      },
      {
        path: "/apply/newVip/13/motorcade/list",
        name: "车队列表"
      },
      {
        path: "/apply/newVip/13/motorcade/group",
        name: "车队分组"
      },
      {
        path: "/apply/newVip/13/motorcade/audit",
        name: "待审核列表"
      },
      {
        path: "/apply/newVip/13/motorcade/set/seting",
        name: "车队设置"
        // children: [
        //   {
        //     path: "/apply/newVip/13/motorcade/set/rank",
        //     name: "车队级别" 没用
        //   },
        //   {
        //     path: "/apply/newVip/13/motorcade/set/seting",
        //     name: "车队设置"
        //   }
        // ]
      }
    ]
  },
  {
    path: "/apply/newVip/13/xuanpinku",
    name: "选品商城",
    icon: "el-icon-s-order",
    children: [
      {
        name: "首页",
        path: "/apply/newVip/13/xuanpinku/xuanpin"
      },
      {
        name: "余额充值",
        path: "/apply/newVip/13/xuanpinku/Prepaid"
      },
      {
        name: "选品平台",
        path: "/apply/newVip/13/xuanpinku/checkgoods"
      },
      {
        name: "设置积分比例",
        path: "/apply/newVip/13/xuanpinku/integral_set"
      },
      {
        name: "兑换订单",
        path: "/apply/newVip/13/xuanpinku/orderList"
      },
      {
        name: "结算信息",
        path: "/apply/newVip/13/xuanpinku/settlement"
      }
    ]
  },
  {
    path: "/apply/newVip/13/order",
    name: "订单",
    icon: "el-icon-s-order",
    children: [
      // {
      //   path: "/apply/newVip/13/order/index",
      //   name: "概览"
      // },

      // {
      //   path: "/apply/newVip/13/order/oilsListNow",
      //   name: "当前班次"
      // },
      // {
      //   path: "/apply/newVip/13/order/recentShift",
      //   name: "最近班次"
      // }, 
      // {
      //   path: "/apply/newVip/13/order/oilsList",
      //   name: "消费订单"
      // },
      // {
      //   path: "/apply/newVip/13/order/voucherList",
      //   name: "充值订单"
      // },
      // {
      //   path: "/apply/newVip/13/order/shopOrder",
      //   name: "非油品订单"
      // },
      {
        path: "/apply/newVip/13/order/shellIntegral",
        name: "积分商城"
      },
      {
        path: "/apply/newVip/13/order/discountsVerification",
        name: "核销记录"
      },
      
      // {
      //   path: "/apply/newVip/13/order/ordinaryList",
      //   name: "普通订单"
      // },
      {
        path: "/apply/newVip/13/order/refundList",
        name: "订单退款列表"
      }
    ]
  },
  {
    path: "/apply/newVip/13/center",
    name: "客户",
    icon: "el-icon-s-custom",
    children: [
      {
        path:
          appid == 387
            ? "/apply/newVip/13/center/WateruserList"
            : "/apply/newVip/13/center/userList", //判断应用是否是387的
        name: "会员列表"
      },
      {
        path: "/apply/newVip/13/center/infor",
        name: "客户概况"
      },
      {
        path: "/apply/newVip/13/center/sign/userSign",
        name: "会员标签"
      },
      {
        path: "/apply/newVip/13/center/userBlacklist",
        name: "会员黑名单"
      },
      {
        path: "/apply/newVip/13/center/userManage/userInquire",
        name: "客户管理",
        children: [
          // {
          //   path: "/apply/newVip/13/center/userManage/userInquire",
          //   name: "客户查询"
          // },
          {
            path: "/apply/newVip/13/center/userManage/userCrowd/sign",
            name: "客户分群"
          },
          {
            path: "/apply/newVip/13/center/userManage/userImport",
            name: "客户导入"
          },
          {
            path: "/apply/newVip/13/center/userManage/labelManage",
            name: "标签管理"
          }
        ]
      },
      {
        path: "/apply/newVip/13/center/userOperation",
        name: "客户运营",
        children: [
          {
            path: "/apply/newVip/13/center/userOperation/crowdOperat",
            name: "人群运营"
          },
          {
            path: "/apply/newVip/13/center/userOperation/sceneOperat",
            name: "场景运营"
          }
        ]
      },
      {
        path: "/apply/newVip/13/center/analyze",
        name: "会员分析"
      }
      // {
      //   path: "/apply/newVip/13/center/import",
      //   name: "会员批量导入"
      // },
      // {
      //   path: "/apply/newVip/13/center/assetTransfer",
      //   name: "会员资产转账"
      // }
    ]
  },
  {
    path: "/apply/newVip/13/market",
    name: "营销",
    icon: "el-icon-star-on",
    children: []
    // children: [
    //   {
    //     path: "/apply/newVip/13/market",
    //     name: "营销中心"
    //   },
    //   {
    //     path: "/apply/newVip/13/marketing/gift",
    //     name: "赠品管理",
    //     children: [
    //       {
    //         path: "/apply/newVip/13/marketing/gift/list",
    //         name: "赠品列表"
    //       },
    //       {
    //         path: "/apply/newVip/13/marketing/gift/ruleList",
    //         name: "赠品规则"
    //       },
    //       {
    //         path: "/apply/newVip/13/marketing/gift/record",
    //         name: "赠品记录"
    //       }
    //     ]
    //   },
    //   {
    //     path: "/apply/newVip/13/refuel/salesPromotion",
    //     name: "促销活动",
    //     children: [
    //       {
    //         path: "/apply/newVip/13/refuel/salesPromotion/promoCode",
    //         name: "优惠码"
    //       },
    //       {
    //         path: "/apply/newVip/13/refuel/salesPromotion/discount",
    //         name: "限时折扣"
    //       }
    //     ]
    //   },
    //   {
    //     path: "/apply/newVip/13/marketing/client",
    //     name: "客户活动",
    //     children: [
    //       {
    //         path:
    //           "/apply/newVip/13/marketing/client/consumption/consumption-list",
    //         name: "消费后有礼"
    //       },
    //       {
    //         path: "/apply/newVip/13/marketing/client/birthday/birthday-list",
    //         name: "生日有礼"
    //       },
    //       {
    //         path: "/apply/newVip/13/marketing/client/rechange/rechange-list",
    //         name: "充值有礼"
    //       },
    //       {
    //         path: "/apply/newVip/13/marketing/client/holiday/holiday-list",
    //         name: "节日有礼"
    //       }
    //     ]
    //   }
    // ]
  },
  {
    path: "/apply/newVip/13/pay",
    name: "支付",
    icon: "el-icon-s-promotion",
    children: [
      {
        path: "/apply/newVip/13/pay",
        name: "支付账号"
      },
      {
        path: "/apply/newVip/13/pay/couponSetting",
        name: "优惠互斥"
      }
    ]
  },
  //
  // {
  //   path: "/apply/newVip/13/data",
  //   name: "报表"
  // },
  {
    path: "/apply/newVip/13/generalize",
    name: "推广",
    icon: "el-icon-share",
    children: []
  },
  {
    path: "/apply/newVip/13/report/myList",
    name: "报表",
    icon: "el-icon-share",
    children: [
      {
        path: "/apply/newVip/13/report/myList",
        name: "我的报表"
      }
    ]
  },
  {
    path: "/apply/newVip/13/set/printList",
    name: "设置",
    icon: "el-icon-s-tools",
    children: [
      // {
      //   path: "/apply/newVip/13/set/sound",
      //   name: "音响设置"
      // },
      {
        path: "/apply/newVip/13/set/printList",
        name: "打印机设置"
      },
      {
        path: "/apply/newVip/13/set/smsConfig",
        name: "短信设置"
      },
      // {
      //   path: "/apply/newVip/13/set/smsTemplate",
      //   name: "短信模板"
      // },
      {
        path: "/apply/newVip/13/set/safety_Set",
        name: "安全设置"
      },
      // {
      //   path: "/apply/newVip/13/set/discountPast",
      //   name: "优惠券设置"
      // },
      {
        path: "/apply/newVip/13/set/menuOptions",
        name: "功能开关"
      },
      {
        path: "/apply/newVip/13/set/replenishment",
        name: "补单"
      },
      {
        path: "/apply/newVip/13/set/ruyiConfig",
        name: "如意设置"
      },
      {
        path: "/apply/newVip/13/set/AccountSecurity",
        name: "账号安全"
      }
    ]
  },
  {
    path: "/apply/newVip/13/set/hardware",
    name: "教学",
    icon: "el-icon-s-tools",
    children: []
  }
];
